"use strict";

exports.__esModule = true;
exports.default = exports.Unwrapped = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _brightDates = require("bright-dates");

var _reactGa = require("react-ga");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _DayPickerPanel = _interopRequireDefault(require("../DayPickerPanel"));

var _Input = _interopRequireDefault(require("../Input"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _zIndex = _interopRequireDefault(require("../../constants/z-index"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _Calendar = _interopRequireDefault(require("../Icons/Calendar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tpadding: 0.75rem 1rem !important;\n\t\t\tmargin: 7px 0 !important;\n\t\t\tborder-radius: 0px !important;\n\t\t\tborder: 2px solid #c3c8cd !important;\n\t\t\tmin-height: 3rem !important;\n\t\t\tfont-family: galano;\n\t\t\tcolor: #404040;\n\t\t\tfont-size: inherit;\n\t\t"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-bottom: 0px !important;\n\t\t\tborder-bottom-left-radius: 0px;\n\t\t\tborder-bottom-right-radius: 0px;\n\t\t\tborder-color: ", " !important;\n\t\t"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tcolor: ", ";\n\t\t\t-webkit-text-fill-color: ", ";\n\t\t\tborder-color: ", " !important;\n\t\t\tbackground-color: ", ";\n\t\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tcursor: ", ";\n\t", ";\n\tuser-select: none;\n\t", ";\n\t", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: ", ";\n\tmargin-left: ", ";\n\tcolor: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\toverflow: hidden;\n\theight: auto;\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\tz-index: ", ";\n\twidth: 100%;\n\tmin-width: 280px;\n\n\t@media (min-width: ", ") {\n\t\t", ";\n\t\twidth: ", ";\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tfont-family: 'galano', sans-serif;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DayPickerInputContainer = _styledComponents.default.div(_templateObject());

DayPickerInputContainer.displayName = 'DayPickerInputContainer';

var Placeholder = _styledComponents.default.span(_templateObject2(), _colors.default.placeholder);

Placeholder.displayName = 'Placeholder';

var DayRangeContainer = _styledComponents.default.div(_templateObject3(), _colors.default.white, _vars.default.boxShadow, _zIndex.default.OVERLAY, _breakpoints.default.tablet, function (props) {
  return props.panelAbsoluteOnDesktop && 'position: absolute';
}, function (props) {
  return props.width || '350px';
});

DayRangeContainer.displayName = 'DayRangeContainer';
var OpenCalendarIcon = (0, _styledComponents.default)(_Calendar.default)(_templateObject4(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, _spacing.default.s1, _colors.default.primary);
OpenCalendarIcon.displayName = 'OpenCalendarIcon';
var InputBox = (0, _styledComponents.default)(_Input.default.withComponent('div'))(_templateObject5(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject6(), _colors.default.disabled, _colors.default.disabled, _colors.default.disabledOutline, _colors.default.disabledBackground);
}, function (props) {
  return props.error && (0, _styledComponents.css)(_templateObject7(), _colors.default.borderError);
}, function (props) {
  return props.legacyInputStyle && (0, _styledComponents.css)(_templateObject8());
});
InputBox.displayName = 'InputBox';

var DayPicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DayPicker, _React$Component);

  function DayPicker(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var open = props.open;
    _this.state = {
      dayPickerOpen: open || false
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = DayPicker.prototype;

  _proto.getDefaultMonth = function getDefaultMonth() {
    var prop = this.props.month;
    var propDate = this.props.range.from;

    if (typeof prop !== 'undefined') {
      return prop;
    }

    if (propDate) {
      return propDate.getMonth();
    }

    return (0, _brightDates.date)().month();
  };

  _proto.getDefaultYear = function getDefaultYear() {
    var prop = this.props.year;
    var propDate = this.props.range.from;

    if (typeof prop !== 'undefined') {
      return prop;
    }

    if (propDate) {
      return propDate.getFullYear();
    }

    var currentYear = (0, _brightDates.date)().year();
    var yearRange = this.props.yearRange;

    if (currentYear <= yearRange.max && currentYear >= yearRange.min) {
      return currentYear;
    }

    return Math.abs(yearRange.max - currentYear) > Math.abs(yearRange.min - currentYear) ? yearRange.min : yearRange.max;
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var _this$props = this.props,
        displayFormat = _this$props.displayFormat,
        dateRange = _this$props.dateRange;

    if (displayFormat) {
      return displayFormat;
    }

    var _this$props$range = this.props.range,
        from = _this$props$range.from,
        to = _this$props$range.to;
    return (0, _brightDates.date)(from).isSame((0, _brightDates.date)(to), 'year') && dateRange ? ['friendlyShort'] : ['friendlyShort', 'year'];
  };

  _proto.closeDayPicker = function closeDayPicker() {
    var onBlur = this.props.onBlur;
    var dayPickerOpen = this.state.dayPickerOpen;
    if (onBlur && dayPickerOpen) onBlur();
    this.setState({
      dayPickerOpen: false
    });
  };

  _proto.handleClickOutside = function handleClickOutside() {
    this.closeDayPicker();
  };

  _proto.toggleDayPicker = function toggleDayPicker() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        GA = _this$props2.GA;
    var dayPickerOpen = this.state.dayPickerOpen;
    if (disabled) return;

    if (GA.category && !dayPickerOpen) {
      (0, _reactGa.event)({
        category: GA.category,
        action: GA.actionId + " - DayPicker Input Open"
      });
    }

    this.setState({
      dayPickerOpen: !dayPickerOpen
    });
  };

  _proto.clearValue = function clearValue() {
    this.applyDate({
      from: undefined,
      to: undefined
    });
  };

  _proto.applyDate = function applyDate(dates) {
    var _this$props3 = this.props,
        dateRange = _this$props3.dateRange,
        onSelectedDate = _this$props3.onSelectedDate;
    var to = dates.to,
        from = dates.from;
    var range = to !== undefined && dateRange ? {
      from: from,
      to: to
    } : {
      from: from,
      to: from
    };
    this.closeDayPicker();
    onSelectedDate(range);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        allowClear = _this$props4.allowClear,
        placeholder = _this$props4.placeholder,
        dateRange = _this$props4.dateRange,
        yearRange = _this$props4.yearRange,
        yearsToDisplay = _this$props4.yearsToDisplay,
        style = _this$props4.style,
        error = _this$props4.error,
        disabled = _this$props4.disabled,
        shortcuts = _this$props4.shortcuts,
        disabledDays = _this$props4.disabledDays,
        GA = _this$props4.GA,
        recordValue = _this$props4.recordValue,
        legacyInputStyle = _this$props4.legacyInputStyle,
        closeButton = _this$props4.closeButton,
        panelAbsoluteOnDesktop = _this$props4.panelAbsoluteOnDesktop,
        onSelectedDate = _this$props4.onSelectedDate,
        rest = _objectWithoutPropertiesLoose(_this$props4, ["allowClear", "placeholder", "dateRange", "yearRange", "yearsToDisplay", "style", "error", "disabled", "shortcuts", "disabledDays", "GA", "recordValue", "legacyInputStyle", "closeButton", "panelAbsoluteOnDesktop", "onSelectedDate"]);

    var dayPickerOpen = this.state.dayPickerOpen;
    var range = this.props.range;
    var fromDate = range.from ? (0, _brightDates.formatDate)((0, _brightDates.date)(range.from), this.getDisplayFormat()) : '';
    var toDate = range.to ? (0, _brightDates.formatDate)((0, _brightDates.date)(range.to), ['friendlyShort', 'year']) : '';
    var datesToDisplay = dateRange && toDate ? fromDate + " - " + toDate : "" + fromDate;

    var width = style.width,
        otherStyles = _objectWithoutPropertiesLoose(style, ["width"]);

    return _react.default.createElement(DayPickerInputContainer, rest, _react.default.createElement(InputBox, {
      onClick: this.toggleDayPicker,
      error: error,
      disabled: disabled,
      legacyInputStyle: legacyInputStyle,
      "data-testid": "input-selector"
    }, datesToDisplay ? _react.default.createElement("span", null, datesToDisplay) : _react.default.createElement(Placeholder, null, placeholder), _react.default.createElement(OpenCalendarIcon, {
      size: 22,
      disabled: disabled
    })), dayPickerOpen && _react.default.createElement(DayRangeContainer, {
      panelAbsoluteOnDesktop: panelAbsoluteOnDesktop,
      style: otherStyles,
      width: width
    }, _react.default.createElement(_DayPickerPanel.default, {
      month: this.getDefaultMonth(),
      year: this.getDefaultYear(),
      yearRange: yearRange,
      yearsToDisplay: yearsToDisplay,
      dateRange: dateRange,
      range: range,
      onApply: this.applyDate,
      recordValue: recordValue,
      GA: GA,
      onClear: allowClear ? this.clearValue : undefined,
      shortcuts: shortcuts,
      disabledDays: disabledDays,
      close: closeButton ? this.closeDayPicker : undefined
    })));
  };

  return DayPicker;
}(_react.default.Component);

exports.Unwrapped = DayPicker;
DayPicker.displayName = 'DayPicker';
DayPicker.propTypes = {
  month: _propTypes.number,
  year: _propTypes.number,
  yearRange: (0, _propTypes.shape)({
    min: _propTypes.number,
    max: _propTypes.number
  }),
  yearsToDisplay: _propTypes.number,
  dateRange: _propTypes.bool,
  onSelectedDate: _propTypes.func.isRequired,
  style: _propTypes.object,
  // eslint-disable-line react/forbid-prop-types
  open: _propTypes.bool,
  recordValue: _propTypes.bool,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    actionId: _propTypes.string
  }).isRequired,
  range: (0, _propTypes.shape)({
    from: (0, _propTypes.instanceOf)(Date),
    to: (0, _propTypes.instanceOf)(Date)
  }).isRequired,
  placeholder: _propTypes.string,
  displayFormat: _propTypes.string,
  allowClear: _propTypes.bool,
  error: _propTypes.bool,
  disabled: _propTypes.bool,
  onBlur: _propTypes.func,
  shortcuts: _propTypes.string,
  disabledDays: _propTypes.array,
  // eslint-disable-line react/forbid-prop-types
  legacyInputStyle: _propTypes.bool,
  closeButton: _propTypes.bool,
  panelAbsoluteOnDesktop: _propTypes.bool
};
DayPicker.defaultProps = {
  recordValue: false,
  month: undefined,
  year: undefined,
  yearRange: {
    min: (0, _brightDates.date)().subtract(1, 'years').year(),
    max: (0, _brightDates.date)().add(1, 'years').year()
  },
  dateRange: false,
  yearsToDisplay: 10,
  open: false,
  placeholder: 'Select date',
  displayFormat: undefined,
  allowClear: true,
  error: false,
  disabled: false,
  onBlur: undefined,
  shortcuts: undefined,
  style: {},
  disabledDays: [],
  legacyInputStyle: false,
  closeButton: false,
  panelAbsoluteOnDesktop: true
};

var _default = (0, _reactOnclickoutside.default)(DayPicker);

exports.default = _default;